/* eslint-disable */

import { formatDate } from '../../tools/utils';
export default {
    props: ['title', 'coverUrl', 'readNum', 'date', 'newsId'],
    name: 'NewsListItem',
    data() {
        return {
          iid: window.__iid
        }
    },
    template: ` <a :href="'/newdetail.html?iid='+ iid+'&id='+newsId" target="_blank"><div class="content">
      <div class="item-container" :style="{'background-image': 'url(' + coverUrl + ')'}">
          <div class="mask"></div>
          <span class="tip-mask">浏览 {{readNum}}</span>
          <div class="infos">
            <div class="title">{{title}}</div>
            <div class="date">
                <span type="ios-time-outline"></span> 发布于：{{date | dateFormat}}
            </div>
          </div>
      </div>
  </div></a>`,
    filters: {
        dateFormat(time) {
            var date = new Date(time);
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    }
}
